<template>
  <div class="sf-label sf-nowrap">
    {{ labelText }}
  </div>
</template>

<script>
import ledgerRange from '@app/utils/ledger-range.js'
import { mapState, mapGetters } from 'vuex'

const EMPTY_RANGE = '-'

export default {
  props: ['value'],
  computed: {
    ...mapState(['graphPeriods', 'datesData', 'graph']),
    ...mapGetters(['isGraphTypeLinechart', 'hasSpecificDates']),
    labelText() {
      if (this.isGraphTypeLinechart) {
        return this.linechartLabelText
      } else {
        return this.piechartLabelText
      }
    },
    piechartLabelText() {
      return this.value.relative
    },
    linechartLabelText() {
      if (this.hasSpecificDates) {
        return this.specificDelta
      } else {
        return this.genericDelta
      }
    },
    genericDelta() {
      const yearSuffix = I18n.t('js.report_graph.x_axis.year_suffix')
      const currentYear = I18n.t('js.report_graph.x_axis.current_year')

      return this.rangeBuilder((delta) => {
        if (delta < 0) {
          return `${delta}${yearSuffix}`
        } else if (delta > 0) {
          return `+${delta}${yearSuffix}`
        } else {
          return currentYear
        }
      })
    },
    specificDelta() {
      return ledgerRange(
        this.datesData.graphPeriodsRangesCalendarYear,
        this.datesData.graphPeriodsRangesBookingYear,
        this.graphPeriods.range.start,
        this.graphPeriods.range.end,
        this.value.delta,
        this.graph.yearType,
        this.graphPeriods.frequency,
        this.graphPeriods.priorYears,
        I18n.t('js.report_graph.edit.graph_values.time_label_connector_word'),
        EMPTY_RANGE
      )
    },
  },
  methods: {
    rangeBuilder(formatter) {
      const start = this.graphPeriods.range.start
      const end = this.graphPeriods.range.end
      if (start === null && end === null) {
        return this.value.relative
      }

      const connectorWord = I18n.t(
        'js.report_graph.edit.graph_values.time_label_connector_word'
      )
      return [start, end]
        .map((delta) => {
          if (delta === null) {
            return delta
          }

          delta += this.value.delta
          return formatter(delta)
        })
        .filter((val) => val !== null)
        .join(` ${connectorWord} `)
    },
  },
}
</script>
